var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4781 7.47301H12.8426C12.5019 7.47319 12.1833 7.30411 11.9925 7.02182L10.5569 4.90637C10.3654 4.62525 10.047 4.45739 9.70683 4.45826H5.12214C3.98949 4.45826 3.07129 5.37646 3.07129 6.50911V18.8142C3.07129 19.9469 3.98949 20.8651 5.12214 20.8651H19.4781C20.6108 20.8651 21.529 19.9469 21.529 18.8142V9.52387C21.529 8.39121 20.6108 7.47301 19.4781 7.47301Z",
    stroke: "#003541",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.07129 10.4879H9.70683C10.0459 10.4877 10.3629 10.32 10.5538 10.0398L11.9894 7.92228C12.1803 7.64138 12.4978 7.47319 12.8375 7.47314",
    stroke: "#003541",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderBlackIcon);
export default __webpack_public_path__ + "static/media/folder-black-icon.51dec4deb56e14c1aa52cd43e8518cac.svg";
export { ForwardRef as ReactComponent };